import { useMemo, useCallback } from 'react';
import { useAppStore } from '../store';
import { getTodayIso, getWeekScope, shiftIsoDate } from '../lib/dateScope';

export function usePlannerWeek() {
  const selectedDate = useAppStore((s) => s.selectedDate);
  const setSelectedDate = useAppStore((s) => s.setSelectedDate);
  const scope = useMemo(() => getWeekScope(selectedDate), [selectedDate]);

  const goToPrev = useCallback(
    () => setSelectedDate(shiftIsoDate(selectedDate, -7)),
    [selectedDate, setSelectedDate]
  );

  const goToNext = useCallback(
    () => setSelectedDate(shiftIsoDate(selectedDate, 7)),
    [selectedDate, setSelectedDate]
  );

  const goToThisWeek = useCallback(
    () => setSelectedDate(getTodayIso()),
    [setSelectedDate]
  );

  return {
    weekStart: scope.weekStart,
    weekDates: scope.weekDates,
    weekLabel: scope.rangeLabel,
    goToPrev,
    goToNext,
    goToThisWeek,
    isCurrentWeek: scope.isCurrentWeek,
  };
}
